// extracted by mini-css-extract-plugin
export default {"container":"_1pG0Y_","contentWrapper":"_1CLA_7","content":"_2pdCd3"};